
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { MasterHelper } from 'src/app/core/utilities';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { ImpactService } from './../../../core/services/impact/impact.service';
import { ImpactAssessmentFilter } from 'src/app/core/models/impact-assessment/impact-assessment-filter';
import { ImpactAssessmentMasterFilter, ImpactAssessmentMasterFilterT6 } from 'src/app/core/models/impact-assessment/impact-assessment-master-filter';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { ImpactAssessmentT5Filter } from 'src/app/core/models/impact-assessment/impact-assessmentT5';
import { ImpactAssessmentFilterT6 } from 'src/app/core/models/impact-assessment/ImpactAssessmentFilterT6';
@Component({
  selector: 'app-impact-assessment-t6-filter',
  templateUrl: './impact-assessment-t6-filter.component.html',
  styleUrls: ['./impact-assessment-t6-filter.component.scss']
})
export class ImpactAssessmentT6FilterComponent {

  @Output() OnFilterT6 = new EventEmitter<any>();
  @ViewChild('autoKeyword') autoKeyword!: MatAutocomplete;
  @ViewChild('keywordInput') keywordInput!: ElementRef<HTMLInputElement>;

  filterPersistenceKey = 'impactAssessmentFiltersT6';
  impactAssessmentFilter: ImpactAssessmentFilterT6;
  masterFilters: ImpactAssessmentMasterFilterT6;
  isPersistFilter = false;

  
  searchedAT: FilterViewModel[] = [];
  searchedIT: FilterViewModel[] = [];
  searchedAS: FilterViewModel[] = [];
  searchedIS: FilterViewModel[] = [];
  searchedJuris: FilterViewModel[] = [];
  searchedAss: FilterViewModel[] = [];

  separatorKeysCodes: number[] = [ENTER, COMMA];
  isLoadingFilters = false;

  searchATCntrl: FormControl = new FormControl();
  searchITCntrl: FormControl = new FormControl();
  searchASCntrl: FormControl = new FormControl();
  searchJurisCntrl: FormControl = new FormControl();
  searchAssCntrl: FormControl = new FormControl();
  keyCtrl = new FormControl();
  filteredKeywords: string[];

  @ViewChild('aTInput')
  aTInput!: ElementRef<HTMLInputElement>;
  @ViewChild('aTAutocomplete')
  aTAutocomplete!: MatAutocomplete;

  @ViewChild('aSInput')
  aSInput!: ElementRef<HTMLInputElement>;
  @ViewChild('aSAutocomplete')
  aSAutocomplete!: MatAutocomplete;

  @ViewChild('jurisInput')
  jurisInput!: ElementRef<HTMLInputElement>;
  @ViewChild('jurisAutocomplete')
  jurisAutocomplete!: MatAutocomplete;

  @ViewChild('assInput')
  assInput!: ElementRef<HTMLInputElement>;
  @ViewChild('assAutocomplete')
  assAutocomplete!: MatAutocomplete;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;

  constructor(private impactService: ImpactService) {
    this.impactAssessmentFilter = new ImpactAssessmentFilterT6();
    this.masterFilters = new ImpactAssessmentMasterFilterT6();

    this.impactAssessmentFilter = MasterHelper.parseImpactAssessmentT6Filters(this.impactAssessmentFilter) as ImpactAssessmentFilterT6;
   
  let strImp =  this.fetchFromBrowser(
      this.filterPersistenceKey
    ) as string;
    const persistFilter = JSON.parse(strImp) as ImpactAssessmentFilterT6;
    if(persistFilter && !persistFilter.RegulationId){
      persistFilter.RegulationId=[];
      this.saveOnBrowser(this.filterPersistenceKey,JSON.stringify(persistFilter));
    }
    if (persistFilter) {
      this.isPersistFilter = true;
      this.impactAssessmentFilter = persistFilter;
    }
    this.filteredKeywords = [];
  }

  ngOnInit(): void {
    this.getMasterFilters();
  }

  initFilters(): void {
    this.impactAssessmentFilter.RegulationId = [];
    this.impactAssessmentFilter.assessmentTeam = [];
    this.impactAssessmentFilter.assessmentStatus = [];
    this.impactAssessmentFilter.searchQuery = [];
    this.impactAssessmentFilter.jurisdiction = [];
    this.impactAssessmentFilter.assessor = [];
    this.impactAssessmentFilter.fromDate = this.masterFilters.fromDate.toString();
    this.impactAssessmentFilter.toDate = this.masterFilters.toDate.toString();
    this.searchedAT = this.masterFilters.assessmentTeam;
    this.searchedAS = this.masterFilters.assessmentStatus;
    this.searchedJuris = this.masterFilters.jurisdictions;
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.impactAssessmentFilter));
    this.OnFilterT6.emit(this.impactAssessmentFilter);
  }

  getMasterFilters(): void {
    this.isLoadingFilters = true;
    this.impactService.getImpactAssessmentT6MasterFilters().subscribe((result: ImpactAssessmentMasterFilterT6) => {
      this.masterFilters = result;
      this.impactAssessmentFilter.fromDate = this.masterFilters.fromDate.toString();
      this.impactAssessmentFilter.toDate = this.masterFilters.toDate.toString();
      this.searchedAT = this.masterFilters.assessmentTeam;
      this.searchedAS = this.masterFilters.assessmentStatus;
      this.searchedJuris = this.masterFilters.jurisdictions;
      this.searchedAss = this.masterFilters.assessors;
      this.isLoadingFilters = false;

      this.searchATCntrl.valueChanges.subscribe((data: any) => {
        this.searchedAT = data ? this.filterData(data, 'AssessmentTeam') : this.masterFilters.assessmentTeam;
      });

      this.searchASCntrl.valueChanges.subscribe((data: any) => {
        this.searchedAS = data ? this.filterData(data, 'AssessmentStatus') : this.masterFilters.assessmentStatus;
      });

      this.searchJurisCntrl.valueChanges.subscribe((data: any) => {
        this.searchedJuris = data ? this.filterData(data, 'Jurisdiction') : this.masterFilters.jurisdictions;
      });

      this.searchAssCntrl.valueChanges.subscribe((data: any) => {
        this.searchedAss = data ? this.filterData(data, 'Assessor') : this.masterFilters.assessors;
      });
    });
  }

  filterData(search: string, filter: string): any {
    switch (filter) {
      case 'AssessmentTeam':
        return this.searchedAT.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
        break;
      case 'AssessmentStatus':
        return this.searchedAS.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
        break;
      case 'Jurisdiction':
        return this.searchedJuris.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
        break;
      case 'Assessor':
        return this.searchedAss.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
        break;
      default:
        return new Array<FilterViewModel>();
        break;
    }
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }

  TriggerAction(): void {
    this.impactAssessmentFilter = MasterHelper.parseImpactAssessmentT6Filters(this.impactAssessmentFilter) as ImpactAssessmentFilterT6;
    this.impactAssessmentFilter.toDate = this.impactAssessmentFilter.toDate ? MasterHelper.bsdatePickerToCorrectDate(this.impactAssessmentFilter.toDate?.toString()) : null;
    this.impactAssessmentFilter.fromDate = this.impactAssessmentFilter.fromDate ? MasterHelper.bsdatePickerToCorrectDate(this.impactAssessmentFilter.fromDate?.toString()) : null;
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.impactAssessmentFilter));
    this.OnFilterT6.emit(this.impactAssessmentFilter);
  }

  // Assessment team events
  addAT(event: MatChipInputEvent): void {
    if (!this.aTAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.impactAssessmentFilter.assessmentTeam as string[]).push(value);
      }
      event.chipInput!.clear();
      this.searchATCntrl.setValue(null);
    }
  }

  selectedATEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.impactAssessmentFilter.assessmentTeam) {
      let sameValueRow = this.impactAssessmentFilter.assessmentTeam.filter(
        (option: any) =>
          option == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.impactAssessmentFilter.assessmentTeam.push(event.option.viewValue);
      }
    }else {
      this.impactAssessmentFilter.assessmentTeam = [];
      this.impactAssessmentFilter.assessmentTeam.push(event.option.viewValue);
    }
    if(this.impactAssessmentFilter.assessmentTeam){
      this.aTInput.nativeElement.value = '';
    }
    this.searchATCntrl.setValue(null);
    this.searchATCntrl.disable();
    this.searchATCntrl.enable();
  }

  removeAT(status: string): void {
    const index = (this.impactAssessmentFilter.assessmentTeam as string[]).indexOf(status);

    if (index >= 0) {
      (this.impactAssessmentFilter.assessmentTeam as string[]).splice(index, 1);
    }
  }

  // Assessment status events
  addAS(event: MatChipInputEvent): void {
    if (!this.aSAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.impactAssessmentFilter.assessmentStatus as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchASCntrl.setValue(null);
    }
  }

  selectedASEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.impactAssessmentFilter.assessmentStatus) {
      let sameValueRow = this.impactAssessmentFilter.assessmentStatus.filter(
        (option: any) =>
          option == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.impactAssessmentFilter.assessmentStatus.push(event.option.viewValue);
      }
    } else {
      this.impactAssessmentFilter.assessmentStatus = [];
      this.impactAssessmentFilter.assessmentStatus.push(event.option.viewValue);
    }
    if(this.impactAssessmentFilter.assessmentStatus){
      this.aSInput.nativeElement.value = '';
    }
    this.searchASCntrl.setValue(null);
    this.searchASCntrl.disable();
    this.searchASCntrl.enable();
  }

  removeAS(status: string): void {
    const index = (this.impactAssessmentFilter.assessmentStatus as string[]).indexOf(status);

    if (index >= 0) {
      (this.impactAssessmentFilter.assessmentStatus as string[]).splice(index, 1);
    }
  }

  // Jurisdiction events
  addJurisdiction(event: MatChipInputEvent): void {
    if (!this.jurisAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.impactAssessmentFilter.jurisdiction as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchJurisCntrl.setValue(null);
    }
  }

  selectedJurisdictionEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.impactAssessmentFilter.jurisdiction) {
      let sameValueRow = this.impactAssessmentFilter.jurisdiction.filter(
        (option: any) =>
          option == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.impactAssessmentFilter.jurisdiction.push(event.option.viewValue);
      }
    } else {
      this.impactAssessmentFilter.jurisdiction = [];
      this.impactAssessmentFilter.jurisdiction.push(event.option.viewValue);
    }
    if( this.impactAssessmentFilter.jurisdiction){
      this.jurisInput.nativeElement.value = '';
    }
    this.searchJurisCntrl.setValue(null);
    this.searchJurisCntrl.disable();
    this.searchJurisCntrl.enable();
  }

  removeJurisdiction(status: string): void {
    const index = (this.impactAssessmentFilter.jurisdiction as string[]).indexOf(status);

    if (index >= 0) {
      (this.impactAssessmentFilter.jurisdiction as string[]).splice(index, 1);
    }
  }

  // Assessor Event
  addAssessor(event: MatChipInputEvent): void {
    if (!this.assAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.impactAssessmentFilter.assessor as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchAssCntrl.setValue(null);
    }
  }

  selectedAssessorEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.impactAssessmentFilter.assessor) {
      let sameValueRow = this.impactAssessmentFilter.assessor.filter(
        (option: any) =>
          option == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.impactAssessmentFilter.assessor.push(event.option.viewValue);
      }
    } else {
      this.impactAssessmentFilter.assessor = [];
      this.impactAssessmentFilter.assessor.push(event.option.viewValue);
    }
    if(this.impactAssessmentFilter.assessor){
      this.assInput.nativeElement.value = '';
    }
    this.searchAssCntrl.setValue(null);
    this.searchAssCntrl.disable();
    this.searchAssCntrl.enable();
  }

  removeAssessor(status: string): void {
    const index = (this.impactAssessmentFilter.assessor as string[]).indexOf(status);

    if (index >= 0) {
      (this.impactAssessmentFilter.assessor as string[]).splice(index, 1);
    }
  }

  // Keywords events
  add(event: MatChipInputEvent): void {
    if (!this.autoKeyword.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        this.impactAssessmentFilter.searchQuery.push(value.trim());
      }

      event.chipInput!.clear();
      this.keyCtrl.setValue(null);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.impactAssessmentFilter.searchQuery) {
      let sameValueRow = this.impactAssessmentFilter.searchQuery.filter(
        (option: any) =>
          option == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.impactAssessmentFilter.searchQuery.push(event.option.viewValue);
      }
    }  else {
      this.impactAssessmentFilter.searchQuery = [];
      this.impactAssessmentFilter.searchQuery.push(event.option.viewValue);
    }
    if(this.impactAssessmentFilter.searchQuery){
      this.keywordInput.nativeElement.value = '';
    }
    this.keyCtrl.setValue(null);
    this.keyCtrl.disable();
    this.keyCtrl.enable();
  }

  remove(searchstr: string): void {
    const index = (this.impactAssessmentFilter.searchQuery as string[]).indexOf(searchstr);

    if (index >= 0) {
      (this.impactAssessmentFilter.searchQuery as string[]).splice(index, 1);
    }
  }

  removeRegulationId(type: string): void {
    if(this.impactAssessmentFilter.RegulationId == null) return;
    const index = this.impactAssessmentFilter.RegulationId.indexOf(+type);

    if (index >= 0) {
      this.impactAssessmentFilter.RegulationId.splice(index, 1);
    }
  }
  // Jurisdiction events
  addRegulationId(event: MatChipInputEvent): void {
    const value = event.value;
    if ((value || '').trim()) {
      if(this.impactAssessmentFilter.RegulationId == null) return;
      this.impactAssessmentFilter.RegulationId.push(+value.trim());
    }
    event.chipInput!.clear();
  }
}

